import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { OrderMasterAPI } from "api/OrderMasterAPI";


export default function OrderMasterTable(props) {

  const [orderMaster, setOrderMaster] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderOrderMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Código", accessor: "codigo", align: "right" },
      { Header: "Cantidad", accessor: "cantidad", align: "right", },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
    ];

    orderMaster?.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        cantidad: element.cantidad,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [orderMaster])


  const getOrderMaster = () => {
    setLoading(dispatch, true)
    return OrderMasterAPI.index(true)
      .then(response => {
        setOrderMaster(response.order_master)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getOrderMaster)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Maestro Pedidos'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderOrderMaster}
      </MDBox>
    </MDBox>
  )

}